import { createTheme } from '@via-profit/ui-kit/ThemeProvider';

// Темы ui-kit - единственный источник цветов интерфейса: компоненты ui-kit
// берут их сами, наши styled-компоненты - через props.theme, а GlobalStyles
// отдаёт их чужому DOM (подсказка и кнопки MapLibre) как CSS-переменные.

export const lightTheme = createTheme({
  isDark: false,
  color: {
    backgroundPrimary: '#f8f9fa',
    backgroundSecondary: '#eef0f2',
    surface: '#ffffff',
    textPrimary: '#202124',
    textSecondary: '#5f6368',
    accentPrimary: '#1a73e8',
    accentPrimaryContrast: '#ffffff',
    accentSecondary: '#202124',
    accentSecondaryContrast: '#ffffff',
    error: '#d32f2f',
    warning: '#b26a00',
    success: '#1e7e34',
  },
});

// холодная сине-бирюзовая гамма, как у тёмного стиля карты
export const darkTheme = createTheme({
  isDark: true,
  color: {
    backgroundPrimary: '#1e2b33',
    backgroundSecondary: '#26363f',
    surface: '#1e2b33',
    textPrimary: '#eceff1',
    textSecondary: '#90a4ae',
    accentPrimary: '#8ab4f8',
    accentPrimaryContrast: '#10202b',
    accentSecondary: '#eceff1',
    accentSecondaryContrast: '#10202b',
    error: '#f28b82',
    warning: '#fdd663',
    success: '#81c995',
  },
});
